module.exports = __webpack_public_path__ + "media/packs/images/state/small/containers_assigned-6b6d8f5a115a4e47cef7852f561655ae.svg";